module.exports = __webpack_public_path__ + "static/media/icon-calendar-blue.ac011430.svg";